import React, { Component } from "react"
import { Route, Switch, Redirect } from "react-router-dom"
import { connect } from 'react-redux'
import Helmet from 'react-helmet'
//import HelmetProvider from 'react-navi-helmet-async'
//import { Redirect } from 'react-router'
import Login from "../components/auth/login"

import PUBLIC_ROUTES from "./publicRoutes"
import AUTH_ROUTES from './authRoutes'
import PATIENTS_ROUTES from "./patientRoutes"
import PATIENTS_PRE_ROUTES from "./patientPreRoutes"
import USER_ROUTES from "./userRoutes"
import ADMIN_ROUTES from "./adminRoutes"
import ADMIN_PSYCHIATRIST_ROUTES from "./adminPsychiatrist"
//import SUPER_ADMIN_ROUTES from "./superAdminRoutes"

class RenderRoutes extends Component {
  constructor() {
      super();
      this.menu = [...AUTH_ROUTES, ...PUBLIC_ROUTES, ...PATIENTS_ROUTES, ...USER_ROUTES, ...ADMIN_ROUTES]
  }

  getMenu = () => {
    if(this.props.role === 1) {
      return [...AUTH_ROUTES, ...PUBLIC_ROUTES, ...PATIENTS_ROUTES, ...USER_ROUTES, ...ADMIN_ROUTES, ...ADMIN_PSYCHIATRIST_ROUTES]
    }

    if(this.props.role === 2) {
      return [...AUTH_ROUTES, ...PUBLIC_ROUTES, ...USER_ROUTES, ...ADMIN_ROUTES, ...ADMIN_PSYCHIATRIST_ROUTES]
    }

    if(this.props.role === 3) {
      return [...AUTH_ROUTES, ...PUBLIC_ROUTES, ...USER_ROUTES, ...ADMIN_ROUTES, ...ADMIN_PSYCHIATRIST_ROUTES]
    }

    if(this.props.role === 5) {
      if(this.props.p_st == 6) {
        return [...AUTH_ROUTES, ...PUBLIC_ROUTES, ...PATIENTS_PRE_ROUTES, ...PATIENTS_ROUTES, ...USER_ROUTES]
      }

      return [...AUTH_ROUTES, ...PUBLIC_ROUTES, ...PATIENTS_PRE_ROUTES, ...USER_ROUTES]
    }

    return [...PUBLIC_ROUTES, ...AUTH_ROUTES]
  }

  UNSAFE_componentWillMount() {
    //console.log('Role: '+this.props.role)
    if(this.props.role === 1) {
      // Super admin //
      this.menu = [...AUTH_ROUTES, ...PUBLIC_ROUTES, ...PATIENTS_ROUTES, ...USER_ROUTES, ...ADMIN_ROUTES, ...ADMIN_PSYCHIATRIST_ROUTES]
    }
    if(this.props.role === 2) {
      // Admin //
      this.menu = [...AUTH_ROUTES, ...PUBLIC_ROUTES, ...USER_ROUTES, ...ADMIN_ROUTES, ...ADMIN_PSYCHIATRIST_ROUTES]
    }
    if(this.props.role === 3) {
      // Clinical //
      if(this.props.sub_role == 32) {
        this.menu = [...AUTH_ROUTES, ...PUBLIC_ROUTES, ...USER_ROUTES, ...ADMIN_ROUTES, ...ADMIN_PSYCHIATRIST_ROUTES]
      } else {
        this.menu = [...AUTH_ROUTES, ...PUBLIC_ROUTES, ...USER_ROUTES, ...ADMIN_ROUTES, ...ADMIN_PSYCHIATRIST_ROUTES]
      }
    }
    if(this.props.role === 5) {
      // Patient //
      if(this.props.p_st == 6) {
        this.menu = [...AUTH_ROUTES, ...PUBLIC_ROUTES, ...PATIENTS_PRE_ROUTES, ...PATIENTS_ROUTES, ...USER_ROUTES]
      } else {
        this.menu = [...AUTH_ROUTES, ...PUBLIC_ROUTES, ...PATIENTS_PRE_ROUTES, ...USER_ROUTES]
      }
    }
  }

  render() {
    if (!this.props.authChecked) {
      return <div>Loading...</div>
    }
    const menu = this.getMenu()
    var get_uri = window.location.pathname
    var sep_uri = get_uri.split("/")
    const except_pages2 = ['member/assessment/csi_redo_wo/tm', 'member/assessment/complete_assessments_wo/tm']
    var get_uri2 = sep_uri[1]+'/'+sep_uri[2]+'/'+sep_uri[3]+'/'+sep_uri[4]
    const except_pages3 = ['forgot_password', 'reset_password']
    return (
      <Switch>
        {menu.map((route, i) => {
          // <RouteWithSubRoutes key={route.key} route={route} />
          if((route.requireAuth !== true || (route.requireAuth === true && this.props.uid > 0))
             || (except_pages2.includes(get_uri2)) || (except_pages3.includes(sep_uri[1]))) {
            return (
              <Route
                key={route.key}
                path={route.path}
                exact={route.exact}
                //component={route.component}
                render={props =>
                  <div>
                    <Helmet>
                      <title>{route.title}</title>
                    </Helmet>
                    {/*<route.component {...props} routes={route.routes}  />*/}
                    {React.createElement(route.component, {
                      ...props,
                      routes: route.routes
                    })}
                  </div>}
              />
            )
          } else {
            return (
              <Route
                key={route.key}
                render={() => <Redirect to="/" />}
              />
            )
          }
        })}
        <Route component={() => <h1>Page Not Found!</h1>} />
      </Switch>
    )
  }
}

const mapStateToProps = (state) => {
  return {
    uid: state.authReducer.uid,
    role: state.authReducer.role,
    sub_role: state.authReducer.sub_role,
    p_st: state.authReducer.p_st,
    authChecked: state.authReducer.authChecked,
  }
}

export default connect(mapStateToProps)(RenderRoutes)
